import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { InputTextModule } from 'primeng/inputtext';
import { MultiSelectModule } from 'primeng/multiselect';
import { PaginatorModule } from 'primeng/paginator';
import { SelectModule } from 'primeng/select';
import { SelectButtonModule } from 'primeng/selectbutton';
import { SliderModule } from 'primeng/slider';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { ButtonModule } from 'primeng/button';
import { DatePickerModule } from 'primeng/datepicker';
import { FluidModule } from 'primeng/fluid';
import { TooltipModule } from 'primeng/tooltip';
import { ToastModule } from 'primeng/toast';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { InputNumberModule } from 'primeng/inputnumber';
import { FileUploadModule } from 'primeng/fileupload';
import { DialogModule } from 'primeng/dialog';
import { AccordionModule } from 'primeng/accordion';
import { CardModule } from 'primeng/card';
import { PickListModule } from 'primeng/picklist';
import { FloatLabelModule } from 'primeng/floatlabel';
import { TabsModule } from 'primeng/tabs';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { TextareaModule } from 'primeng/textarea';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { PasswordModule } from 'primeng/password';
import { CheckboxModule } from 'primeng/checkbox';
import { StepsModule } from 'primeng/steps';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { InputMaskModule } from 'primeng/inputmask';
import { FieldsetModule } from 'primeng/fieldset';
import { ProgressBarModule } from 'primeng/progressbar';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { BadgeModule } from 'primeng/badge';
import { PopoverModule } from 'primeng/popover';

import { ConfirmDialog } from 'primeng/confirmdialog';

import { IconField } from 'primeng/iconfield';
import { InputIcon } from 'primeng/inputicon';
import { GalleriaModule } from 'primeng/galleria';

import { FilterService } from 'primeng/api';
import { CarouselModule } from 'primeng/carousel';
import { PanelModule } from 'primeng/panel';

import { MegaMenu } from 'primeng/megamenu';
import { TreeModule } from 'primeng/tree';

import { RadioButtonModule } from 'primeng/radiobutton';

import { Listbox } from 'primeng/listbox';
import { OverlayBadgeModule } from 'primeng/overlaybadge';

import { ScrollTopModule } from 'primeng/scrolltop';
import { MenuModule } from 'primeng/menu';
import { RippleModule } from 'primeng/ripple';
import { AvatarModule } from 'primeng/avatar';
import { SpeedDialModule } from 'primeng/speeddial';
import { DividerModule } from 'primeng/divider';
import { ToggleSwitchModule } from 'primeng/toggleswitch';

@NgModule({
    providers: [FilterService],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        InputTextModule,
        MultiSelectModule,
        PaginatorModule,
        SelectModule,
        SelectButtonModule,
        SliderModule,
        TableModule,
        TagModule,
        DatePickerModule,
        FluidModule,
        TooltipModule,
        ToastModule,
        DynamicDialogModule,
        InputNumberModule,
        FileUploadModule,
        DialogModule,
        AccordionModule,
        CardModule,
        PickListModule,
        FloatLabelModule,
        TabsModule,
        ProgressSpinnerModule,
        AutoCompleteModule,
        TextareaModule,
        ConfirmDialogModule,
        PasswordModule,
        CheckboxModule,
        StepsModule,
        BreadcrumbModule,
        ButtonModule,
        InputGroupModule,
        InputGroupAddonModule,
        InputMaskModule,
        FieldsetModule,
        ProgressBarModule,
        BadgeModule,
        ConfirmDialog,
        IconField,
        InputIcon,
        GalleriaModule,
        CarouselModule,
        PanelModule,
        MegaMenu,
        ConfirmPopupModule,
        PopoverModule,
        TreeModule,
        RadioButtonModule,
        TextareaModule,
        InputNumberModule,
        Listbox,
        ScrollTopModule,
        OverlayBadgeModule,
        MenuModule, RippleModule, BadgeModule, AvatarModule, SpeedDialModule,
        PasswordModule,
        DividerModule,
        ToggleSwitchModule,
        SpeedDialModule
    ],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        InputTextModule,
        MultiSelectModule,
        PaginatorModule,
        SelectModule,
        SelectButtonModule,
        SliderModule,
        TableModule,
        TagModule,
        DatePickerModule,
        FluidModule,
        TooltipModule,
        ToastModule,
        DynamicDialogModule,
        InputNumberModule,
        FileUploadModule,
        DialogModule,
        AccordionModule,
        CardModule,
        PickListModule,
        FloatLabelModule,
        TabsModule,
        ProgressSpinnerModule,
        AutoCompleteModule,
        TextareaModule,
        ConfirmDialogModule,
        PasswordModule,
        CheckboxModule,
        StepsModule,
        BreadcrumbModule,
        ButtonModule,
        InputGroupModule,
        InputGroupAddonModule,
        InputMaskModule,
        FieldsetModule,
        ProgressBarModule,
        BadgeModule,
        ConfirmDialog,
        IconField,
        InputIcon,
        GalleriaModule,
        CarouselModule,
        PanelModule,
        MegaMenu,
        ConfirmPopupModule,
        PopoverModule,
        TreeModule,
        RadioButtonModule,
        TextareaModule,
        InputNumberModule,
        Listbox,
        ScrollTopModule,
        OverlayBadgeModule,
        MenuModule, RippleModule, BadgeModule, AvatarModule, SpeedDialModule,
        PasswordModule,
        DividerModule,
        ToggleSwitchModule,
        SpeedDialModule
    ]
})
export class PrimengSharedModule { }
